import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value - hours * 3600) / 60);
    const seconds = value - hours * 3600 - minutes * 60;

    const parts = [];
    if (hours) {
      parts.push(hours + 'h');
    }
    if (minutes) {
      parts.push(minutes + 'm');
    }
    if (seconds || !parts.length) {
      parts.push(seconds + 's');
    }

    return parts.join(' ');
  }
}
